export default "__VITE_ASSET__d6e37d8f__"